import styled from "styled-components";
import cssVars from "../../../../styles/cssVariables.vars";

export const StyledSessionCard = styled.article`
    --state-color: ${cssVars.colorGrey[5]};

    &.state-CONNECTED { --state-color: rgb(46, 170, 90); }
    &.state-QR_PENDING { --state-color: rgb(230, 155, 30); }
    &.state-STARTING { --state-color: var(--color-btn-schedules); }
    &.state-DISCONNECTED { --state-color: rgb(220, 60, 55); }

    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 1.25rem;
    background-color: ${cssVars.colorGrey[7]};
    border-radius: 0.5rem;
    border-left: 4px solid var(--state-color);
    min-width: 0;

    >header {
        display: flex;
        align-items: flex-start;
        gap: 0.75rem;

        >.identity {
            flex: 1;
            min-width: 0;

            >h3 {
                font-size: 1.125rem;
                font-weight: 600;
                color: ${cssVars.colorGrey[1]};
                overflow-wrap: anywhere;
            }

            >p {
                margin-top: 0.25rem;
                font-size: 0.75rem;
                color: ${cssVars.colorGrey[4]};
                overflow-wrap: anywhere;
            }
        }

        >.status {
            display: flex;
            align-items: center;
            gap: 0.375rem;
            flex-shrink: 0;
            padding: 0.25rem 0.625rem;
            border-radius: 1rem;
            font-size: 0.75rem;
            font-weight: 600;
            color: var(--state-color);
            border: 1px solid var(--state-color);
            white-space: nowrap;

            >span {
                width: 0.5rem;
                height: 0.5rem;
                border-radius: 50%;
                background-color: var(--state-color);
            }
        }
    }

    >.qr {
        display: flex;
        align-items: center;
        gap: 1rem;
        flex-wrap: wrap;

        >div {
            padding: 0.5rem;
            background-color: white;
            border-radius: 0.25rem;
            line-height: 0;
        }

        >p {
            flex: 1;
            min-width: 10rem;
            font-size: 0.8125rem;
            line-height: 1.4;
            color: ${cssVars.colorGrey[3]};

            >small {
                display: block;
                margin-top: 0.25rem;
                color: ${cssVars.colorGrey[4]};
            }
        }
    }

    >dl {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0.875rem 1rem;

        >div {
            min-width: 0;

            >dt {
                font-size: 0.6875rem;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 0.02em;
                color: ${cssVars.colorGrey[4]};
            }

            >dd {
                margin-top: 0.25rem;
                font-size: 0.875rem;
                font-weight: 500;
                color: ${cssVars.colorGrey[1]};
                font-variant-numeric: tabular-nums;
                overflow-wrap: anywhere;

                >small {
                    display: block;
                    margin-top: 0.125rem;
                    font-size: 0.75rem;
                    font-weight: 400;
                    color: ${cssVars.colorGrey[4]};
                }
            }
        }
    }

    >.reason {
        font-size: 0.75rem;
        color: ${cssVars.colorGrey[3]};
        padding: 0.5rem 0.75rem;
        border-radius: 0.25rem;
        background-color: ${cssVars.colorGrey[8]};
        overflow-wrap: anywhere;
    }

    >footer {
        display: flex;
        gap: 0.5rem;
        flex-wrap: wrap;
        margin-top: auto;
        padding-top: 0.75rem;
        border-top: 1px solid ${cssVars.colorGrey["6h"]};

        >p {
            font-size: 0.75rem;
            color: ${cssVars.colorGrey[4]};
        }

        >button {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.5rem 0.75rem;
            border-radius: 0.25rem;
            border: 1px solid ${cssVars.colorGrey[4]};
            background-color: transparent;
            color: ${cssVars.colorGrey[2]};
            font-size: 0.8125rem;
            font-weight: 500;
            cursor: pointer;
            transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;

            >svg {
                font-size: 0.875rem;
            }

            &:hover:not([disabled]) {
                background-color: ${cssVars.colorGrey[2]};
                border-color: ${cssVars.colorGrey[2]};
                color: ${cssVars.colorGrey[8]};
            }

            &.danger {
                border-color: rgb(220, 60, 55);
                color: rgb(220, 60, 55);

                &:hover:not([disabled]) {
                    background-color: rgb(220, 60, 55);
                    color: white;
                }
            }

            &[disabled] {
                opacity: 0.5;
                cursor: default;
            }
        }
    }
`;
